import React, { useEffect, useState } from 'react'
import { Navbar, Container, Nav } from 'react-bootstrap'

import navIcon1 from '../assets/img/nav-icon1.svg'
import navIcon4 from '../assets/img/nav-icon4.svg'

const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }

        window.addEventListener("scroll", onScroll);


        return () => window.removeEventListener("scroll", onScroll);
    }, [])

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }
    return (
        <>
            <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
                <Container>
                    {/* <Navbar.Brand href="#home">
                        <img src={logo} alt='Logo' />
                    </Navbar.Brand> */}
                    <Navbar.Toggle aria-controls="basic-navbar-nav">
                        <span className='navbar-toggler-icon'></span>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="#home"
                                className={activeLink === 'home' ?
                                    'active navbar-link' : 'navbar-link'}
                                onClick={() => onUpdateActiveLink('home')}>
                                Home</Nav.Link>
                            <Nav.Link href="#skills"
                                className={activeLink === 'skills' ?
                                    'active navbar-link' : 'navbar-link'}
                                onClick={() => onUpdateActiveLink('skills')}>
                                Skills</Nav.Link>
                            <Nav.Link href="#projects"
                                className={activeLink === 'projects' ?
                                    'active navbar-link' : 'navbar-link'}
                                onClick={() => onUpdateActiveLink('projects')}>
                                Projects</Nav.Link>
                        </Nav>
                        <span className='navbar-text'>
                            <div className='social-icon'>
                                <a href='https://www.linkedin.com/in/akshay-shrivastava-b63231172/' target="_blank" rel="noopener noreferrer">
                                    <img src={navIcon1} alt="" />
                                </a>
                                <a href='https://github.com/akshim1702' target="_blank" rel="noopener noreferrer">
                                    <img src={navIcon4} alt="" />
                                </a>

                                {/* <a href='#'><img src={navIcon3} alt="" /></a> */}
                            </div>
                            {/* <button className='vvd' onClick={() => console.log('connect')}> <span>Let's connect</span></button> */}
                        </span>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

export default NavBar